import { render, staticRenderFns } from "./FavoriteEmailAdd.vue?vue&type=template&id=28af8d03&scoped=true&"
import script from "./FavoriteEmailAdd.vue?vue&type=script&lang=js&"
export * from "./FavoriteEmailAdd.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteEmailAdd.vue?vue&type=style&index=0&id=28af8d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af8d03",
  null
  
)

export default component.exports